"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryPage = void 0;
const react_1 = __importDefault(require("react"));
const doshx_controls_web_1 = require("doshx_controls_web");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../constants/routes");
const react_redux_1 = require("react-redux");
const log_in_1 = require("./pages/log_in");
const forgot_password_1 = require("./pages/forgot_password");
const reset_password_1 = require("./pages/reset_password");
const sign_up_1 = require("./pages/sign_up");
const side_image_png_1 = __importDefault(require("../../assets/side-image.png"));
const otp_1 = require("./pages/otp");
const EntryPage = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { entryTheme } = (0, react_redux_1.useSelector)((state) => state.entryState);
    const entryRoutes = (0, react_router_dom_1.useRoutes)([
        { index: true, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: routes_1.WELCOME_ROUTE + routes_1.LOG_IN_ROUTE }) },
        { path: routes_1.LOG_IN_ROUTE, element: react_1.default.createElement(log_in_1.LogInPage, null) },
        { path: routes_1.SIGN_UP_ROUTE, element: react_1.default.createElement(sign_up_1.SignUpPage, null) },
        { path: routes_1.FORGOT_PASSWORD_ROUTE, element: react_1.default.createElement(forgot_password_1.ForgotPasswordPage, null) },
        { path: `${routes_1.RESET_PASSWORD_ROUTE}/:forgot_password_id`, element: react_1.default.createElement(reset_password_1.ResetPasswordPage, null) },
        { path: `${routes_1.OTP_ROUTE}/:forgot_password_id`, element: react_1.default.createElement(otp_1.OTPPage, null) },
    ]);
    return (react_1.default.createElement("div", { className: "h-full" },
        react_1.default.createElement("div", { className: "flex flex-col lg:flex-row h-full" },
            react_1.default.createElement("div", { className: "flex flex-col h-1/2 lg:h-auto flex-1 p-4 relative" },
                react_1.default.createElement("img", { src: side_image_png_1.default, className: "absolute top-0 left-0 object-cover object-center w-full h-full -z-10" }),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement("div", { className: "flex justify-center lg:pt-20" },
                        react_1.default.createElement("div", { className: `flex flex-col gap-4 drop-shadow-lg decoration-[#000000] text-7xl 
                  ${entryTheme.config.colors.slogan.text} font-bold` }, entryTheme.config.slogan))),
                react_1.default.createElement("div", { className: "hidden lg:block absolute left-0 bottom-0 p-4" },
                    react_1.default.createElement(doshx_controls_web_1.CopyrightControl, { size: "small", company: "", backgroundColor: "bg-transparent", textColor: "text-white" }))),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center p-4" },
                entryRoutes,
                react_1.default.createElement("div", { className: "lg:hidden w-full p-4" },
                    react_1.default.createElement(doshx_controls_web_1.CopyrightControl, { size: "small", position: "center", company: "", backgroundColor: "bg-transparent", textColor: "text-black" }))))));
};
exports.EntryPage = EntryPage;
